import React,{useState,useEffect} from 'react';
import { Worker , Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { thumbnailPlugin } from '@react-pdf-viewer/thumbnail';

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const PdfViewer = (props) => {
 const defaultLayoutPluginInstance = defaultLayoutPlugin({
  thumbnailPlugin: {
      thumbnailWidth: 50,
  },
});
 
  const [fileUrl, setFileUrl] = useState("");
  const handleDocumentLoad = (DocumentLoadEvent) => {
    const { activateTab } = defaultLayoutPluginInstance;
    activateTab(0);
};
  useEffect(() => {
    if (props.myContent !== undefined) {
      setFileUrl(props.myContent)
    }else{
      setFileUrl("")
    }
  
  }, [props]);

  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
      <div className="viewer-height">
        <Viewer
          fileUrl={fileUrl}
           plugins={[defaultLayoutPluginInstance]}
          onDocumentLoad={handleDocumentLoad}
        />
      </div>
    </Worker>
  );
}

export default PdfViewer;